import React from "react";

function SimpleNotification() {
  return <div>Simple Notification</div>;
}

export default SimpleNotification;
